import { css } from "styled-components";
import { getTypographyStyle } from "./util/getTypographyStyle";

export const LabelStyles = css(
    ({ theme }) => css`
        .Label {
            color: ${theme.palette.gray["900"]};
            ${getTypographyStyle("body3Regular")}
        }
    `,
);
